<div *ngIf="rows.length" class="d-flex flex-column break-inside-avoid">
  <div class="dynamic-form-calc-table__header-row d-flex">
    <div
      *ngFor="let cell of cells | keyvalue"
      class="flex-1 bold"
      [style.order]="cell.value.index"
    >
      {{ cell.value.label }}
    </div>
  </div>

  <div
    *ngFor="let row of rows; let index = index; trackBy: trackByFn"
    @listItem
    (@listItem.done)="animationDone.emit($event)"
    class="dynamic-form-calc-table__row px-1 py-1_5 position-relative"
  >
    <div
      *ngIf="distinctBy && (cells | get : distinctBy) as distinctCell"
      class="dynamic-form-calc-table__grouped d-flex align-items-center pb-2 mb-2"
    >
      <span class="mat-small">{{ distinctCell.label }}</span>
      <span class="bold ps-1"
        ><ng-container
          *ngTemplateOutlet="
            cellTmpl;
            context: {
              $implicit: {
                pair: {
                  key: distinctBy,
                  value: row.item | get : distinctBy,
                },
                cellDef: cells[distinctBy],
                parentValue: row.item
              }
            }
          "
        ></ng-container
      ></span>
    </div>
    <div class="position-relative d-flex">
      <ng-container
        *ngFor="
          let cell of row.item | keyvalue;
          let first = first;
          let last = last
        "
      >
        <ng-container *ngIf="cell.key !== distinctBy && cells[$any(cell.key)]">
          <div
            *ngrxLet="cells[$any(cell.key)] as cellDef"
            class="dynamic-form-calc-table__cell d-flex flex-column px-_5"
            [style.width.%]="cellWidth"
            [style.order]="cellDef.index"
            [ngClass]="{
              'justify-content-center': !cellDef.index,
              'justify-content-start': cellDef.index,
            }"
          >
            <div class="dynamic-form-calc-table__value">
              <ng-container
                *ngTemplateOutlet="
                  cellTmpl;
                  context: {
                    $implicit: { pair: cell, cellDef, parentValue: row.item }
                  }
                "
              ></ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="dynamic-form-calc-table__actions">
      <lui-context-menu-container>
        <button
          [luiContextMenuButtonFor]
          [matMenuTriggerFor]="menu"
          type="button"
        >
          <mat-icon svgIcon="more"></mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="edit.emit(row.__meta.id)">
            <mat-icon svgIcon="edit"></mat-icon>
            <span i18n>Edit</span>
          </button>
          <button mat-menu-item (click)="delete.emit(row.__meta.id)">
            <mat-icon svgIcon="trash"></mat-icon>
            <span i18n>Delete</span>
          </button>
        </mat-menu>
      </lui-context-menu-container>
    </div>
  </div>

  <div
    class="dynamic-form-calc-table__row dynamic-form-calc-table__row--summary d-flex py-1_5 px-1"
    *ngIf="total"
  >
    <div
      class="dynamic-form-calc-table__cell d-flex flex-column justify-content-center px-_5"
      [style.width.%]="cellWidth"
      [style.order]="0"
    >
      <div class="dynamic-form-calc-table__key">
        <span>{{ total.label }}</span>
      </div>
    </div>
    <ng-container
      *ngFor="
        let cell of totals | keyvalue | reject : distinctBy ?? '' : 'key';
        let last = last
      "
    >
      <div
        *ngIf="cells[$any(cell.key)]?.index as order"
        class="dynamic-form-calc-table__cell d-flex flex-column justify-content-center px-_5"
        [style.width.%]="cellWidth"
        [style.order]="order"
      >
        <div class="dynamic-form-calc-table__value bold" *ngIf="cell?.value">
          <span>{{ total.addonLeft }}</span>
          <span>{{ cell.value | number : total.decimalFormat }}</span>
          <span>{{ total.addonRight }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #cellTmpl let-item>
  <lockton-apps-dynamic-form-cell
    *ngIf="item.pair | fieldMeta : fields as meta"
    [type]="meta.type"
    [value]="item.pair.value"
    [parentValue]="item.parentValue"
    [addonLeft]="item.cellDef.addonLeft"
    [addonRight]="item.cellDef.addonRight"
    [decimalFormat]="item.cellDef.decimalFormat"
    [options]="meta.options$ | async"
    [displayWith]="meta.displayWith"
    (customEvent)="customEvent.emit($event)"
  ></lockton-apps-dynamic-form-cell>
</ng-template>
